import { render, staticRenderFns } from "./updateCallback.vue?vue&type=template&id=fa6890c4&scoped=true&"
import script from "./updateCallback.vue?vue&type=script&lang=js&"
export * from "./updateCallback.vue?vue&type=script&lang=js&"
import style0 from "./updateCallback.vue?vue&type=style&index=0&id=fa6890c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6890c4",
  null
  
)

export default component.exports